import type { AuthResponse } from "@upsquad/shared";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { setRefreshToken as setPersistedRefreshToken, setUser } from "@/src/auth/store/auth-slice";
import { getSubdomain } from "@/src/common/lib/subdomain";
import { useAppDispatch } from "@/src/common/redux/store";
import { baseApi } from "@/src/common/services/base-api";
import { setAccessToken, setRefreshToken } from "@/src/common/services/http.service";
import { setCommunities } from "@/src/community/store/community-slice";
import { POST_ROUTES } from "@/src/post/constants/post-routes";

export interface AuthSuccessResult {
	communities: AuthResponse["communities"];
	user: AuthResponse["user"];
}

export function useAuthSuccess() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	return useCallback(
		(response: AuthResponse, options?: { skipNavigate?: boolean }): AuthSuccessResult => {
			dispatch(baseApi.util.resetApiState());

			setAccessToken(response.access_token);
			setRefreshToken(response.refresh_token);
			dispatch(setUser(response.user));
			dispatch(setPersistedRefreshToken(response.refresh_token));
			dispatch(setCommunities(response.communities));

			if (!options?.skipNavigate) {
				const subdomain = getSubdomain();
				navigate(subdomain ? POST_ROUTES.FEED : "/");
			}

			return { communities: response.communities, user: response.user };
		},
		[dispatch, navigate],
	);
}
